import { parseUserPreferredSizes } from 'integration/hooks/usePreferredSizes';
import type { DppMemberPromotion } from '@/data/dpp/types';

export type PersonalizationSizes = Partial<
	Record<'tops' | 'shirts' | 'pants' | 'footwear' | 'caps', string>
>;

const SIZE_LABELS = ['FOOTWEAR', 'TOPS', 'SHIRTS', 'PANTS', 'CAPS'];

export const personalizationSizesFromProfile = (
	sizes?: string
): PersonalizationSizes | undefined => {
	const chosen = parseUserPreferredSizes(sizes).flatMap(({ label, value }) =>
		SIZE_LABELS.includes(label) && value ? [[label.toLowerCase(), value]] : []
	);
	return chosen.length ? Object.fromEntries(chosen) : undefined;
};

const toSizeValue = (value: string) => {
	const number = Number(value);
	return Number.isFinite(number) ? String(number) : value;
};

export const personalizationSizesFromDpp = (
	sizes?: DppMemberPromotion['sizes']
): PersonalizationSizes | undefined => {
	const chosen = Object.entries(sizes ?? {}).flatMap(([label, size]) => {
		const value = size?.value?.trim();
		return SIZE_LABELS.includes(label) && value ? [[label.toLowerCase(), toSizeValue(value)]] : [];
	});
	return chosen.length ? Object.fromEntries(chosen) : undefined;
};
